import React from 'react';
import PropTypes from 'prop-types';
import BaseNext from '../base-next';

const StreetTwo = props => {
  const {
    onChange,
    value,
    error,
    touched,
    onBlur,
    id,
    isDisabled,
    isCosigner
  } = props;
  return (
    <BaseNext
      isDisabled={isDisabled}
      data-cv-test="addressStreetLineTwo"
      onChange={onChange}
      onBlur={onBlur}
      value={value}
      touched={touched}
      error={error}
      id={id}
      type="text"
      labelText={isCosigner ? 'Apt, Suite, Building' : 'Address, Line 2 (optional)'}
      maxLength={201}
      isCosigner={isCosigner}
    />
  );
};

StreetTwo.propTypes = {
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.string,
  touched: PropTypes.bool,
  isDisabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  id: PropTypes.string,
  isCosigner: PropTypes.bool
};

StreetTwo.defaultProps = {
  onChange: () => {},
  onBlur: () => {},
  value: '',
  touched: false,
  error: false,
  isDisabled: false,
  id: '',
  isCosigner: false
};

export default StreetTwo;
